// PickupTaskListModel class
class PickupTaskListModel {
    constructor({
                    count = null,
                    total = null,
                    pageSize = null,
                    current = null,
                    results = [],
                } = {}) {
        this.count = count;
        this.total = total;
        this.pageSize = pageSize;
        this.current = current;
        this.results = results.map((item) => new Results(item));
    }

    // Method to parse JSON into the model
    static fromJson(json) {
        return new PickupTaskListModel({
            count: json.count,
            total: json.total,
            pageSize: json.page_size,
            current: json.current,
            results: json.results?.map((item) => Results.fromJson(item)) || [],
        });
    }

    // Method to convert the model back to JSON
    toJson() {
        return {
            count: this.count,
            total: this.total,
            page_size: this.pageSize,
            current: this.current,
            results: this.results.map((item) => item.toJson()),
        };
    }
}

// Results class
class Results {
    constructor({
                    id = null,
                    orderId = null,
                    awb = null,
                    boxCount = null,
                    concept = null,
                    vendorLocation = null,
                    isMps = null,
                    originHub = null,
                    returnHub = null,
                    direction = null,
                    contactNumber = null,
                    city = null,
                    area = null,
                    address = null,
                    orderBookedAt = null,
                    pickupInfoName = null,
                    assetId = null,
                } = {}) {
        this.id = id;
        this.orderId = orderId;
        this.awb = awb;
        this.boxCount = boxCount;
        this.concept = concept;
        this.vendorLocation = vendorLocation;
        this.isMps = isMps;
        this.originHub = originHub;
        this.returnHub = returnHub;
        this.direction = direction;
        this.contactNumber = contactNumber;
        this.city = city;
        this.area = area;
        this.address = address;
        this.orderBookedAt = orderBookedAt;
        this.pickupInfoName = pickupInfoName;
        this.assetId = assetId;
    }

    // Method to parse JSON into the model
    static fromJson(json) {
        return new Results({
            id: json.id,
            orderId: json.order_id,
            awb: json.awb,
            boxCount: json.box_count,
            concept: json.concept,
            vendorLocation: json.vendor_location,
            isMps: json.is_mps,
            originHub: json.origin_hub,
            returnHub: json.return_hub,
            direction: json.direction,
            contactNumber: json.contact_number,
            city: json.city,
            area: json.area,
            address: json.address,
            orderBookedAt: json.order_booked_at,
            pickupInfoName: json.pickup_info_name,
            assetId: json.asset_id,
        });
    }

    // Method to convert the model back to JSON
    toJson() {
        return {
            id: this.id,
            order_id: this.orderId,
            awb: this.awb,
            box_count: this.boxCount,
            concept: this.concept,
            vendor_location: this.vendorLocation,
            is_mps: this.isMps,
            origin_hub: this.originHub,
            return_hub: this.returnHub,
            direction: this.direction,
            contact_number: this.contactNumber,
            city: this.city,
            area: this.area,
            address: this.address,
            order_booked_at: this.orderBookedAt,
            pickup_info_name: this.pickupInfoName,
            asset_id: this.assetId,
        };
    }
}

export {PickupTaskListModel, Results};
